export const sameDay = (expected : Date, compare : Date) => {
    return expected.getFullYear() === compare.getFullYear()
        && expected.getMonth() === compare.getMonth()
        && expected.getDate() === compare.getDate();
}

export const getTimestamp = (dateStr : string) => {
    if (dateStr) {
        const timestamp = new Date(dateStr);
        if (timestamp) {
            const today = new Date();
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);

            var options : Intl.DateTimeFormatOptions;
            var prefix : string = '';
            if (sameDay(timestamp, today) || sameDay(timestamp, yesterday)) {
                options = {
                    hour12: false,
                    hour: 'numeric', minute: 'numeric'
                };

                if (sameDay(timestamp, today)) {
                    prefix = 'Heute, ';
                } else {
                    prefix = 'Gestern, ';
                }
            } else {
                options = {
                    weekday: 'short',
                    // year: 'numeric', 
                    month: '2-digit', day: '2-digit',
                    hour12: false,
                    hour: 'numeric', minute: 'numeric'
                };
            }
    
            const timeStampFormatted = prefix + new Intl.DateTimeFormat('de-DE', options).format(timestamp) + ' Uhr';
            return <span>{timeStampFormatted}</span>;
        }
    }
    return null;
}

export const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

export const buamatogVerificationKey = () => {
    const buamatogyear = (new Date()).getFullYear();
    return 'buamatog-verification-' + buamatogyear;
}